import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import FormModal from '../Components/FormModal.js'

function Branches () {
  const pageName = 'branches'
  const pageTitle = "Filiallar";
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}` 
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters:true,
    pagination:true,
    editLink: rowData => `/${pageName}/${rowData.id}`,
    actions: {
      get: async (params = {}) => {
        const branches = await call.forLoggedUser.branch.getBranches(params)
        if (branches.success) {
          return branches.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Ad',
        property: 'name',
        style: {width:'35%'},
        filter: {
          enabled: true,
          type: 'text',
          name:'name'
        }
      },
      {
        title: 'Kod',
        property: 'code',
        style: {width:'10%'},
        filter: {
          enabled: true,
          type: 'text',
          name:'code'
        }
      },
      {
        title: 'Ünvan',
        property: 'address',
        style: {width:'30%'},
        filter: {
          enabled: true,
          type: 'text',
          name:'address'
        }
      },
      {
        title: 'Status',
        property: 'statusName',
        type:'status-label',
        filter: {
          enabled: true,
          type: 'select',
          name:'statusId',
          dataSource:async ()=> {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'branch'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        style: {width:'15%'},
        mutate: value => {
          return value
        }
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'branch',
      label: 'Filial',
      isStandAlone: true,
      isMain: true,
      id: '',
      actions: {
        get: id => call.forLoggedUser.branch.getBranchById({ id: id }),
        add: call.forLoggedUser.branch.addBranch,
        edit: call.forLoggedUser.branch.updateBranch
      },
      formLists:{
        Statuses:async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'branch'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Adı',
          fieldName: 'name',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Kod',
          fieldName: 'code',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Ünvan',
          fieldName: 'address',
          col: { sm: 6 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          defaultValue: 1,
          col: { sm: 3 },
          data:'Statuses' 
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Branches
